/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{VertexArrayObject as e}from"../../../webgl/VertexArrayObject.js";class r extends e{}export{r as VertexArrayObject};
